'use client';

import * as React from 'react';
import { motion, useAnimation, type Variants } from 'framer-motion';

interface SparklesIconProps {
	isHovered: boolean;
}

const sparkleVariants: Variants = {
	normal: {
		y: 0,
		fill: 'transparent',
	},
	animate: {
		y: [0, -1, 0, 0],
		fill: '#FF69B4',
		transition: {
			duration: 1,
			bounce: 0.3,
		},
	},
};

const starVariants: Variants = {
	normal: {
		opacity: 1,
		x: 0,
		y: 0,
		stroke: 'currentColor',
	},
	animate: {
		opacity: [0, 1, 0, 0, 0, 0, 1],
		stroke: '#FFD700',
		transition: {
			duration: 2,
			type: 'spring',
			stiffness: 70,
			damping: 10,
			mass: 0.4,
		},
	},
};

export function SparklesIcon({ isHovered }: SparklesIconProps) {
	const starControls = useAnimation();
	const sparkleControls = useAnimation();

	React.useEffect(() => {
		if (isHovered) {
			void sparkleControls.start('animate');
			void starControls.start('animate');
		} else {
			void sparkleControls.start('normal');
			void starControls.start('normal');
		}
	}, [isHovered, sparkleControls, starControls]);

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<motion.path
					d='M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z'
					variants={sparkleVariants}
					animate={sparkleControls}
				/>
				<motion.path
					d='M20 3v4'
					variants={starVariants}
					animate={starControls}
				/>
				<motion.path
					d='M22 5h-4'
					variants={starVariants}
					animate={starControls}
				/>
				<motion.path
					d='M4 17v2'
					variants={starVariants}
					animate={starControls}
				/>
				<motion.path
					d='M5 18H3'
					variants={starVariants}
					animate={starControls}
				/>
			</svg>
		</div>
	);
}
